<template>
<div class="chapter">
<div class="inner_page">
<p class="block_11">
<i class="calibre1">
</i><i class="calibre1" id="id_toc"></i></p>
<p class="block_12"><a class="text_" href="#/index_split_007#id_Toc100507708">Prologue</a></p>
<p class="block_12"><a class="text_" href="#/index_split_008#id_Toc100507709">Chapter 1</a></p>
<p class="block_12"><span class="text_" href="#/index_split_009#id_Toc100507710" title="Link target outside of Sample">Chapter 2</span></p>
<p class="block_12"><span class="text_" href="#/index_split_010#id_Toc100507711" title="Link target outside of Sample">Chapter 3</span></p>
<p class="block_12"><span class="text_" href="#/index_split_011#id_Toc100507712" title="Link target outside of Sample">Chapter 4</span></p>
<p class="block_12"><span class="text_" href="#/index_split_012#id_Toc100507713" title="Link target outside of Sample">Chapter 5</span></p>
<p class="block_12"><span class="text_" href="#/index_split_013#id_Toc100507714" title="Link target outside of Sample">Chapter 6</span></p>
<p class="block_12"><span class="text_" href="#/index_split_014#id_Toc100507715" title="Link target outside of Sample">Chapter 7</span></p>
<p class="block_12"><span class="text_" href="#/index_split_015#id_Toc100507716" title="Link target outside of Sample">Chapter 8</span></p>
<p class="block_12"><span class="text_" href="#/index_split_016#id_Toc100507717" title="Link target outside of Sample">Chapter 9</span></p>
<p class="block_12"><span class="text_" href="#/index_split_017#id_Toc100507718" title="Link target outside of Sample">Chapter 10</span></p>
<p class="block_12"><span class="text_" href="#/index_split_018#id_Toc100507719" title="Link target outside of Sample">Chapter 11</span></p>
<p class="block_12"><span class="text_" href="#/index_split_019#id_Toc100507720" title="Link target outside of Sample">Chapter 12</span></p>
<p class="block_12"><span class="text_" href="#/index_split_020#id_Toc100507721" title="Link target outside of Sample">Chapter 13</span></p>
<p class="block_12"><span class="text_" href="#/index_split_021#id_Toc100507722" title="Link target outside of Sample">Chapter 14</span></p>
<p class="block_12"><span class="text_" href="#/index_split_022#id_Toc100507723" title="Link target outside of Sample">Chapter 15</span></p>
<p class="block_12"><span class="text_" href="#/index_split_023#id_Toc100507724" title="Link target outside of Sample">Epilogue</span></p>
<p class="block_12"><span class="text_" href="#/index_split_024#id_Toc100507725" title="Link target outside of Sample">Author’s Note</span></p>
<p class="block_12"><span class="text_" href="#/index_split_025#id_Toc100507726" title="Link target outside of Sample">About the Author</span></p>
<p class="block_12"><span class="text_" href="#/index_split_026#id_Toc100507727" title="Link target outside of Sample">A Sneak Peek of LITTLE DOES SHE KNOW</span></p>
<p class="block_12"><span class="text_" href="#/index_split_026#id_Toc100507728" title="Link target outside of Sample">Chapter 1: Ginger Mallowan</span></p>
<p class="block_12"><span class="text_" href="#/index_split_027#id_Toc100507729" title="Link target outside of Sample">LITTLE DOES SHE KNOW</span></p>
<p class="block_13"></p>
<p class="block_14" id="calibre_pb_4"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_004.vue?f580cfb4